import { Action } from '..';
import { IFormValues } from '../../task/collectFeedback/Setup';
import { ITaskThreadItem } from '../../task/query';

export interface IExtendedFormValues extends IFormValues {
    id: string;
}

export interface TaskState {
    editAnswer: ITaskThreadItem | null;
    savedCollectFeedbackForm: IExtendedFormValues | null;
}

const initialState: TaskState = {
    editAnswer: null,
    savedCollectFeedbackForm: null,
};

export function reducer(state: TaskState = initialState, action: Action): TaskState {
    switch (action.type) {
        case 'EDIT_TASK_ANSWER':
            return {
                ...state,
                editAnswer: action.item,
            };
        case 'CANCEL_TASK_EDIT_ANSWER':
            return {
                ...state,
                editAnswer: null,
            };
        case 'SAVE_COLLECT_FEEDBACK_FORM':
            return {
                ...state,
                savedCollectFeedbackForm: action.data,
            };
        case 'CLEAR_COLLECT_FEEDBACK_FORM':
            return {
                ...state,
                savedCollectFeedbackForm: null,
            };
        default:
            return state;
    }
}